import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { DropdownMenu, DropdownMenuItem, TextButton, Tooltip, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './AddNewItemButtons.module.scss';
export const GetAddNewItemButtonsTID = (parentTestId)=>getTestIds(parentTestId);
const AddNewItemButtons = (param)=>{
    let { serviceOptions, handleAddServiceFromAgreement, handleAddOutOfScopeCharge, handleAddServiceInStages } = param;
    const { t: addNewItemButtonsTexts } = useLocaleKeys('components.addNewItemButtons');
    const { AddNewItemButtonsTID } = useMemo(()=>GetAddNewItemButtonsTID(), []);
    const onAddService = (serviceId, stageNumber, billingStages)=>{
        if (stageNumber && billingStages) {
            handleAddServiceInStages({
                serviceId,
                stageNumber,
                billingStages
            });
        } else {
            handleAddServiceFromAgreement({
                serviceId
            });
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(TextButton, {
                underline: "none",
                testId: AddNewItemButtonsTID.AddCharge(),
                bi: {
                    name: 'add_out_of_scope_charge'
                },
                onClick: handleAddOutOfScopeCharge,
                children: addNewItemButtonsTexts.addOutOfScopeCharge()
            }),
            serviceOptions.length > 0 ? /*#__PURE__*/ _jsx(DropdownMenu, {
                hAlign: "left",
                maxHeight: 200,
                width: 320,
                target: /*#__PURE__*/ _jsx(TextButton, {
                    bi: {
                        name: 'add_service_from_agreement'
                    },
                    underline: "none",
                    testId: AddNewItemButtonsTID.AddService(),
                    children: addNewItemButtonsTexts.addServiceFromAgreement()
                }),
                children: serviceOptions.map((param, index)=>{
                    let { name, costString, disabledReason, id, stageNumber, billingStages } = param;
                    return /*#__PURE__*/ _jsxs(DropdownMenuItem, {
                        height: 56,
                        testId: AddNewItemButtonsTID.ServiceOption(index),
                        bi: {
                            name: 'add_service_from_agreement',
                            data: {
                                serviceId: id
                            }
                        },
                        onClick: ()=>onAddService(id, stageNumber, billingStages),
                        disabled: disabledReason.isDisabled,
                        tooltipProps: disabledReason.isDisabled ? {
                            title: disabledReason.reasonTooltip,
                            placement: 'right'
                        } : undefined,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                ellipsis: true,
                                className: styles.menuItem,
                                variant: "paragraph1",
                                skin: disabledReason.isDisabled ? 'disabled' : undefined,
                                testId: AddNewItemButtonsTID.ServiceOptionTitle(index),
                                children: name
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.subtitle,
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        ellipsis: true,
                                        variant: "paragraph1",
                                        skin: disabledReason.isDisabled ? 'disabled' : 'secondary',
                                        children: costString
                                    }),
                                    stageNumber && billingStages && /*#__PURE__*/ _jsx(Typography, {
                                        testId: AddNewItemButtonsTID.ServiceOptionStage(index),
                                        ellipsis: true,
                                        variant: "paragraph1",
                                        skin: disabledReason.isDisabled ? 'disabled' : 'secondary',
                                        children: addNewItemButtonsTexts.stageInfo({
                                            stageNumber,
                                            total: billingStages.length
                                        })
                                    })
                                ]
                            })
                        ]
                    }, stageNumber !== undefined ? "".concat(id, "-").concat(stageNumber) : id);
                })
            }) : /*#__PURE__*/ _jsx(Tooltip, {
                title: addNewItemButtonsTexts.noManualServicesTooltip(),
                placement: "bottom-start",
                children: /*#__PURE__*/ _jsx(Typography, {
                    skin: "disabled",
                    variant: "paragraph1",
                    testId: AddNewItemButtonsTID.AddServiceTooltip(),
                    children: addNewItemButtonsTexts.addServiceFromAgreement()
                })
            })
        ]
    });
};
export default AddNewItemButtons;
